// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Wz5Q","content":"styles_content__2BLLU","row":"styles_row__1grV6","footer":"styles_footer__2sK84","phraseLength":"styles_phraseLength__38IiJ"};